var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewProfileButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039",
    transform: "translate(-1584 -32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038",
    transform: "translate(-189 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_606",
    "data-name": "Ellipse 606",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(1773 18)",
    fill: "#fed700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036",
    transform: "translate(-182.9 5.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-person",
    "data-name": "Icon material-person",
    d: "M22.257,22.257a8.128,8.128,0,1,0-8.128-8.128A8.126,8.126,0,0,0,22.257,22.257Zm0,4.064C16.831,26.321,6,29.044,6,34.449v4.064H38.514V34.449C38.514,29.044,27.683,26.321,22.257,26.321Z",
    transform: "translate(1781.9 41.098)",
    fill: "#1a1a1a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProfileButton);
export default __webpack_public_path__ + "static/media/newProfileButton.b2b3f53f8c7d9389645476f7156bda10.svg";
export { ForwardRef as ReactComponent };